<button type="button" (click)="op.toggle($event)" class="btn secondary-outline-button" [ngClass]=""
  title="{{'General.help.visualize'|translate}}">
  <i aria-hidden=" true" class="fa fa-2x fa-question">
    <p *ngIf="helpElementsCount > 0" aria-hidden="true" class="badge badge-danger  help-badged"> {{ helpElementsCount }}
    </p>
  </i>
</button>
<p-overlayPanel #op id="helpPanel" (onShow)="showPanel();" [showCloseIcon]="true" [dismissable]="false"
  [styleClass]="'plyca-helpelementresult text-left'" [baseZIndex]="9999" [autoZIndex]="true"
  [appendTo]="this.isModal?'#headercontainer':'body'">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <span *ngIf="this.searching" class="leyenda">
          <i class="fa fa-spinner loading-spin" aria-hidden="true"></i> {{'Help.searching' | translate}}</span>
        <plyca-helpElementResult [searchTags]="searchTags" [groupedHelp]="groupedHelp"></plyca-helpElementResult>
      </div>
    </div>
  </div>
</p-overlayPanel>